import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TrainingFollowUpAttendanceSheetVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrieveAttendanceSheets = createAsyncThunk<
  TrainingFollowUpAttendanceSheetVM[],
  string,
  { extra: Partial<Dependencies> }
>("trainingFollowUps/adminRetrieveAttendanceSheets", async (trainingFollowUpId: string, { extra: { adminRepository } }) => {
  return adminRepository!.getAttendanceSheets(trainingFollowUpId);
});
